var Actions;
(function (Actions) {
    Actions["GET_LIST"] = "getAllDashboardReportList";
    Actions["HANDLE_SORT_CHANGE"] = "handleDashboardReportListSortChange";
    Actions["HANDLE_CURRENT_PAGE_CHANGE"] = "handleDashboardReportListPageChange";
    Actions["DOWNLOAD_DASHBOARD_REPORT"] = "downloadDashboardReport";
    Actions["EXPORT_DASHBOARD_REPORT"] = "exportDashboardReport";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_LIST"] = "setDashboardReportList";
    Mutations["SET_PAGINATION_TOTAL_PAGE"] = "setDashboardReportListPaginationTotalPage";
    Mutations["SET_PAGINATION_CURRENT_PAGE_CHANGE"] = "setDashboardReportListCurrentPageChange";
    // set loading
    Mutations["SET_PAGINATION_LOADING"] = "setDashboardReportListPaginationLoading";
    Mutations["SET_LOADING"] = "setDashboardReportLoading";
    Mutations["SET_MODAL_LOADING"] = "setDashboardReportModalLoading";
    // filter
    Mutations["SET_FILTER"] = "setDashboardReportFilter";
    Mutations["CLEAR_FILTER"] = "clearDashboardReportFilter";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
